module.exports = "/images/default-album.png?a1a07eafd43e81af1f0dfd8fb4f5a7a6";